import { loaderTimeoutInMilliseconds, withTimeout } from "@gamedev-web/gamedev-sdk-core";

import { loadableOptionalComponent as loadable } from "../../loadable";

export const ToolsPane = loadable(() =>
  withTimeout(loaderTimeoutInMilliseconds, import("./ToolsPane"))
);
